// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ShareToggle = registerClientReference(
    function() { throw new Error("Attempted to call ShareToggle() from the server but ShareToggle is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/charts/share-toggle.tsx",
    "ShareToggle",
);
